if (!customElements.get("custom-oos")) {
  customElements.define(
    "custom-oos",
    class CustomOOS extends HTMLElement {
      constructor() {
        super();
        this.variant_id = this.dataset.variantId;
        this.email = this.dataset.email;
        this.modal_id = this.dataset.modalId;
      }
      connectedCallback() {
        this.button = this.querySelector("button");
        if (this.button) {
          this.button.addEventListener(
            "click",
            this.handleButtonClick.bind(this),
          );
        }
        //set variant on variant change
        document.body.addEventListener(
          "variantChange",
          this.handleVariantChange.bind(this),
        ); //user changes main product variant
      }

      handleButtonClick(e) {
        e.preventDefault();

        //always open popup
        //get modal here instead of load as js removes element and clones appends it
        const modal = document.getElementById(this.modal_id);
        if (!modal) {
          this.handleError();
        }
        modal.show();
        return;
      }

      handleVariantChange(e) {
        var current_variant = e.detail.currentVariant;
        if (current_variant) {
          this.variant_id = current_variant.id;

          //handle unabailable
          if (current_variant.available) {
            this.classList.add("hidden");
          } else {
            this.classList.remove("hidden");
          }
        }
      }

      submitOOS({ email = false, phone = false, subscribe = false }) {
        //set loading state
        this.querySelector(".loading-overlay__spinner")?.classList.remove(
          "hidden",
        );
        this.button.classList.add("loading");
        this.button.setAttribute("aria-disabled", true);

        //close modal
        const modal = document.getElementById(this.modal_id);
        if (modal) {
          modal.hide();
        }
        if (email) {
          this.email = email;
        }

        var profile_attribute = !phone
          ? {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: this.email,
                  },
                },
              },
              channels: ["EMAIL"],
            }
          : {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: this.email,
                    phone_number: phone,
                  },
                },
              },
              channels: ["EMAIL", "SMS"],
            };

        const payload = {
          data: {
            type: "back-in-stock-subscription",
            attributes: profile_attribute,
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${this.variant_id}`,
                },
              },
            },
          },
        };

        var requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2025-04-15",
          },
          body: JSON.stringify(payload),
        };

        fetch(
          "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=j5hyQm",
          requestOptions,
        )
          .then((result) => {
            this.classList.add("success");
            setTimeout(() => {
              this.classList.remove("success");
            }, 2000);
          })
          .catch((error) => console.log("error", error))
          .finally(() => {
            this.querySelector(".loading-overlay__spinner")?.classList.add(
              "hidden",
            );
            this.button.classList.remove("loading");
            this.button.setAttribute("aria-disabled", false);
          });

        //send subscribe post
        if (subscribe) {
          this.subscribeUser(this.email, phone);
        }
      }

      subscribeUser(email, phone = false) {
        debugger;
        var profile_attribute = !phone
          ? {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED",
                        },
                      },
                    },
                  },
                },
              },
            }
          : {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    phone_number: phone,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED",
                        },
                      },
                      sms: {
                        marketing: {
                          consent: "SUBSCRIBED",
                        },
                      },
                    },
                  },
                },
              },
            };

        const payload = {
          data: {
            type: "subscription",
            attributes: profile_attribute,
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: "L6EHn9",
                },
              },
            },
          },
        };

        var requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2025-04-15",
          },
          body: JSON.stringify(payload),
        };

        fetch(
          "https://a.klaviyo.com/client/subscriptions/?company_id=j5hyQm",
          requestOptions,
        )
          .then((result) => console.log(result))
          .catch((error) => console.log("error", error));
      }
      setError() {
        this.classList.add("error");
        setTimeout(() => {
          this.classList.remove("error");
        }, 2000);
      }
    },
  );
}

if (!customElements.get("custom-oos-details")) {
  customElements.define(
    "custom-oos-details",
    class CustomOOSDetails extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        //get matching oos to submit form
        const oos_id = this.dataset.oos;
        this.oos = document.getElementById(oos_id);
        if (!this.oos) {
          this.handleError();
        }

        var button = this.querySelector("button");
        this.email = this.querySelector("#email");
        this.phone = this.querySelector("#phone");
        this.subscribe_el = this.querySelector("#subscribe");

        if (!button) {
          this.handleError();
        }
        if (!this.email) {
          this.handleError();
        }

        button.addEventListener("click", this.handleButtonClick.bind(this));
        this.email.addEventListener("keydown", this.handleKeyDown.bind(this));
      }
      handleButtonClick(e) {
        e.preventDefault();

        var valid_email = this.validateEmail();
        if (!valid_email) {
          return;
        }
        this.handleSubmit();
      }
      handleKeyDown(e) {
        if (e.key == "Enter") {
          e.preventDefault();
          this.handleSubmit();
        }
      }
      validateEmail() {
        var is_valid = true;

        if (!this.email.checkValidity()) {
          this.email.reportValidity();
          is_valid = false;
        }
        if (!this.phone.checkValidity()) {
          this.phone.reportValidity();
          is_valid = false;
        }

        return is_valid;
      }
      handleSubmit() {
        var valid_email = this.validateEmail();

        if (!valid_email) return;

        const email = this.email.value.trim();

        var phone = false;
        if (this.phone.value.trim().length > 0) {
          phone = this.convertToE164Simple(this.phone.value.trim());
        }
        const subscribe = this.subscribe_el.checked;

        this.oos.submitOOS({ email, phone, subscribe });

        return true;
      }

      convertToE164Simple(phoneNumber, defaultCountryCode = 61) {
        let cleanedNumber = phoneNumber.replace(/\D/g, ""); // Remove all non-digit characters

        // IMPORTANT: This part assumes `defaultCountryCode` is the numeric code (e.g., "61")
        // And it makes a specific assumption about how the local number might start.
        // For Australia (61), national numbers often start with a '0'.
        // We need to remove this '0' if the number is being treated as a national number
        // that needs to be internationalized.

        // If the number already starts with the default country code (e.g., "61...")
        // or a "+" followed by the country code, we assume it's already in an
        // international-ish format, and we just clean it up.
        if (cleanedNumber.startsWith(defaultCountryCode)) {
          // Already includes the country code, just ensure it's not double-prefixed later
          // and handle any existing '+' if it was part of the original input.
          cleanedNumber = cleanedNumber;
        } else if (cleanedNumber.startsWith("0")) {
          // If it starts with '0' (common for national dialing in many countries like AU),
          // and doesn't already have the international prefix, we strip the '0'
          // and then prepend the defaultCountryCode.
          cleanedNumber = defaultCountryCode + cleanedNumber.substring(1);
        } else {
          // It's a local number without a leading '0' or country code, just prepend
          cleanedNumber = defaultCountryCode + cleanedNumber;
        }

        // Ensure it starts with a '+'
        if (!cleanedNumber.startsWith("+")) {
          cleanedNumber = "+" + cleanedNumber;
        }

        // E.164 max length is 15 digits (excluding the '+').
        // So, total length with '+' is 16.
        if (cleanedNumber.length > 16) {
          // This truncation can lead to invalid numbers if the original was longer
          // than 15 digits for a valid reason or if it included an extension.
          console.warn(
            `Warning: Number ${cleanedNumber} was truncated to 15 digits for E.164 compliance.`,
          );
          cleanedNumber = cleanedNumber.substring(0, 16);
        }

        return cleanedNumber;
      }
    },
  );
}
